export default __webpack_public_path__ + "static/media/t2-p3-img1.1b36832a.png";